/**
 * *Done*, beside the collapse toggle, shown only while the rail is in edit mode.
 * Edit mode is entered from a rail right-click menu (*Edit sidebar*) — sections
 * are made once or twice a year, so there is no permanent control for it — but
 * leaving it needs a visible way out.
 */
import React from 'react';

import { useRailEditStore } from './useRailEditStore';

/** Done while editing; nothing otherwise. `mr-auto` keeps it left of the collapse toggle. */
const RailEditToggle: React.FC = () => {
  const editing = useRailEditStore(s => s.editing);
  const setEditing = useRailEditStore(s => s.setEditing);
  if (!editing) return null;
  return (
    <button
      type="button"
      onClick={() => setEditing(false)}
      className="text-sidebar-foreground hover:bg-sidebar-accent mr-auto rounded-md px-2 py-1 text-xs font-medium transition-colors"
    >
      Done
    </button>
  );
};

export default RailEditToggle;
